import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

import { initializeGtm } from './utils/analytics';
import { initializeCookieConsent } from './utils/cookieConsent';
import { applyEarlyShareUrlSeo } from './utils/seo';

applyEarlyShareUrlSeo();

// Klaro must restore consent and emit gtag updates before GTM loads.
if (typeof window !== 'undefined') {
  initializeCookieConsent();
}

const Root = () => {
  useEffect(() => {
    initializeGtm();
  }, []);

  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
};

createRoot(document.getElementById('root')!).render(<Root />);
